var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm10 5a1 1 0 011-1h.01a1 1 0 110 2H12a1 1 0 01-1-1zm-.093-8.729A2 2 0 0113.92 10V10c0 .47-.365.958-1.055 1.418a6.046 6.046 0 01-1.246.628l-.016.006a1 1 0 00.633 1.897L11.92 13c.316.949.317.948.318.948h.001l.004-.002.011-.003.035-.012.116-.043a8.036 8.036 0 001.57-.806c.81-.54 1.945-1.55 1.945-3.081a4 4 0 00-7.773-1.333 1 1 0 101.886.664 2 2 0 01.874-1.06z",
    fill: "#0073F7"
  })));
}

export default SvgQuestion;